<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-12-13 15:02:07
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-20 12:02:22
 * @FilePath: \miniproweb\src\views\UserMsg\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="useBody">
    <div class="useTitleBox">用户反馈</div>
    <div class="sendInfoBox">
      <el-input placeholder v-model="tel">
        <template slot="prepend">联系方式:</template>
      </el-input>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 4}"
        placeholder="请输入反馈内容"
        v-model="textarea3"
        style="margin-top:15px"
      ></el-input>
      <div class="submitBtn" @click="submitData">提交反馈</div>
    </div>
    <div class="listBox">
      <div class="ListTile">历史反馈:</div>
      <div class="listItem" v-for="item in msgList">
        <div class="qurTitle">
          <div>反馈内容:</div>
          <div style="margin-top:5px;font-size:14px">{{item.proDescription}}</div>
          <div style="width:100%;text-align:right;font-size:12px">{{item.createDate}}</div>
          <div>回复内容:</div>
          <div style="margin-top:5px;font-size:14px">{{item.replyDescription}}</div>
          <div style="width:100%;text-align:right;font-size:12px">{{item.replyDate}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea3: "",
      myopenId: "",
      tel: "",
      msgList: []
    };
  },
  created() {
    // this.getUserMsgData();
    let myCode = this.getQueryString("code");
    // console.log(this.getQueryString("code"));
    if (myCode == null) {
      alert("授权失败");
    } else {
      // alert(myCode);
      this.getOpenId(myCode);
    }
  },
  methods: {
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    getUserMsgData() {
      this.$axios({
        url: `http://120.79.183.250:3093/InterfaceServices/UserFeedbackService/queryUserFeedbackByUserId?userId=${this.myopenId}&pageNum=1&pageSize=10` // 接口地址
      })
        .then(response => {
          console.log(response.data.data);
          this.msgList = response.data.data;
        })
        .catch(error => console.log(error, "error")); // 失败的返回
    },
    getOpenId(id) {
      this.$axios({
        url: `http://120.79.183.250:3093/InterfaceServices/WechatService/queryWechatOauth2Token?code=${id}` // 接口地址
      })
        .then(response => {
          // alert(id);
          // alert(response.data.data);
          // console.log(JSON.parse(response.data.data));
          this.myopenId = JSON.parse(response.data.data).openid;
          this.getUserMsgData();
          // console.log(this.myopenId);
          // alert(this.myopenId);
        })
        .catch(error => console.log(error, "error")); // 失败的返回
    },
    submitData() {
      this.$axios({
        method: "POST",
        url: `http://120.79.183.250:3093/InterfaceServices/UserFeedbackService/saveUserFeedback`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          proDescription: this.textarea3,
          userId: this.myopenId,
          proDescriptionImg: "",
          proType: "",
          userName: "匿名"
        }
      }).then(res => {});
    }
  }
};
</script>

<style>
.useBody {
  height: 100vh;
  width: 100vw;
  background-color: #111b2f;
  overflow: auto;
}
.useTitleBox {
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 40px;
  background-color: #323d56;
  color: white;
}
.sendInfoBox {
  height: auto;
  width: 100%;
  /* background-color: rgb(77, 163, 238); */
  padding: 0 20px;
  margin-top: 50px;
}
.submitBtn {
  height: 40px;
  width: 100%;
  background-color: #42a0fd;
  text-align: center;
  line-height: 40px;
  color: white;
  margin-top: 15px;
  border-radius: 5px;
}
.listBox {
  width: 100%;
  height: 300px;
  /* background-color: #42a0fd; */
  padding: 0 20px;
  margin-top: 15px;
}
.ListTile {
  height: 40px;
  color: white;
  line-height: 40px;
}
.listItem {
  height: auto;
  width: 100%;
  background-color: #323d55;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 15px;
}
.qurTitle {
  color: white;
}
</style>